import React, { useState } from 'react';

const ContactUsComponent = props => {
    return (
        <div className={`modal-popup-contact ${props.isShowContactPopup ? "on" : ""}`}>
            <div className='content'>
                <div className='body'>
                    <button
                        onClick={props.onClickBtnCloseContactPopup}
                        className="btn-close-modal">
                        <i></i>
                    </button>
                    <form>
                        <h3>CONTACT</h3>
                        <div className='row'>
                            <label>
                                <span className='text'>
                                    TITLE
                                    </span>
                                <div className='input'>
                                    <input
                                        onChange={evt => props.onChangeInputText('title', evt)}
                                        className='outline' type='text' placeholder="Please enter your title." defaultValue={props.info.title} />
                                </div>
                            </label>
                        </div>
                        <div className='row'>
                            <label>
                                <span className='text'>
                                    EMAIL
                                    </span>
                                <div className='input'>
                                    <input
                                        onChange={evt => props.onChangeInputText('email', evt)}
                                        className='outline' type='text' placeholder="Please enter your email address at company." defaultValue={props.info.email} />
                                </div>
                            </label>
                        </div>
                        <div className='row'>
                            <label>
                                <span className='text'>
                                    COMPANY</span>
                                <div className='input'>
                                    <input
                                        onChange={evt => props.onChangeInputText('company', evt)}
                                        className='outline' type='text' placeholder="Please enter your company name." defaultValue={props.info.company} />
                                </div>
                            </label>
                        </div>
                        <div className='row'>
                            <label>
                                <span className='text'>
                                    NAME
                                    </span>
                                <div className='input'>
                                    <input
                                        onChange={evt => props.onChangeInputText('name', evt)}
                                        className='outline' type='text' placeholder="For example: Andrew Smith." defaultValue={props.info.name} />
                                </div>
                            </label>
                        </div>
                        <div className='row'>
                            <label>
                                <span className='text'>
                                    PHONE
                                    </span>
                                <div className='input'>
                                    <input
                                        onChange={evt => props.onChangeInputText('phone', evt)}
                                        className='outline' type='text' placeholder="Please enter your phone number." defaultValue={props.info.phone} />
                                </div>
                            </label>
                        </div>
                        <div className='row'>
                            <label>
                                <span className='text'>
                                    MESSAGE
                                    </span>
                                <div className='textarea'>
                                    <textarea
                                        onChange={evt => props.onChangeInputText('message', evt)}
                                        className='outline' placeholder="Please enter your message." defaultValue={props.info.message}></textarea>
                                </div>
                            </label>
                        </div>
                        <button
                            onClick={props.onClickBtnSend}
                            className='btn-contact-send'>
                            SEND</button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ContactUsComponent;